module.exports = __webpack_public_path__ + "img/icon_pause_0.c24380ba.svg";